import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import {
    CrmUpdateTaskOnCallPayload,
    GetCustomersParams,
    GetCustomersResponse,
    GetSourcesResponse,
    GetTasksParams,
    GetTasksResponse,
    GetWaitListProcessingStatusesResponse,
} from '@/new-services/types/crm'

type ApiGetCustomersResponse = Promise<AxiosResponse<GetCustomersResponse>>
type ApiGetTasksResponse = Promise<AxiosResponse<GetTasksResponse>>
type ApiGetWaitListProcessingStatusesResponse = Promise<
    AxiosResponse<GetWaitListProcessingStatusesResponse>
>
type ApiGetSourcesResponse = Promise<AxiosResponse<GetSourcesResponse>>
type ApiUpdateTaskOnCallResponse = Promise<AxiosResponse<void>>
type ApiSendTaskOnCallResponse = Promise<AxiosResponse<void>>

export function getCustomers(params: GetCustomersParams): ApiGetCustomersResponse {
    return http.get('/crm/api/customers/by-operator-email', { params })
}

export function getTasks(params: GetTasksParams): ApiGetTasksResponse {
    return http.get('/crm/api/tasks-to-calls', { params })
}

export function getWaitListProcessingStatuses(): ApiGetWaitListProcessingStatusesResponse {
    return http.get('/crm/api/wait-lists/processing-statuses')
}

export function getSources(): ApiGetSourcesResponse {
    return http.get('/crm/api/tasks-to-calls/sources')
}

export function updateTaskOnCall(
    id: number,
    payload: CrmUpdateTaskOnCallPayload
): ApiUpdateTaskOnCallResponse {
    return http.put(`/crm/api/tasks-to-calls/${id}`, payload)
}

export function sendTaskOnCall(id: number): ApiSendTaskOnCallResponse {
    return http.post(`/crm/api/tasks-to-calls/${id}/send-call`, {})
}

export default {
    getCustomers,
    getTasks,
    getWaitListProcessingStatuses,
    updateTaskOnCall,
    sendTaskOnCall,
    getSources,
}
